import React from 'react';

import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from './utils';


/**
 * Floating popover per the DESIGN.md `autocomplete`/menu spec: surface-3
 * popover, hairline border, 8px radius, soft shadow. Built on
 * @radix-ui/react-popover (positioning, focus, dismiss, a11y).
 *
 *   <Popover>
 *     <PopoverTrigger asChild><Button>Open</Button></PopoverTrigger>
 *     <PopoverContent>…</PopoverContent>
 *   </Popover>
 */
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverClose = PopoverPrimitive.Close;

const PopoverContent = React.forwardRef((props, ref) => {
  const {
    className,
    align = 'center',
    sideOffset = 6,
    ...restProps
  } = props;

  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'z-50 w-72 rounded-md border border-hairline bg-surface-3 p-3 text-ink',
          'shadow-popover outline-none',
          'data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-95',
          'data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95',
          className,
        )}
        {...restProps}
      />
    </PopoverPrimitive.Portal>
  );
});
PopoverContent.displayName = 'PopoverContent';

export {
  Popover,
  PopoverAnchor,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
};
export default Popover;
